import { PayloadAction } from '../../../../../store.model';
import { ActionType } from '../transcript-summary.action';
import { TranscriptSummaryState } from '../transcript-summary.state';

import {
    DeleteTranscript,
    DeleteTranscriptResult,
} from './delete-transcript.action';

export function deleteTranscriptReducer(
    state: TranscriptSummaryState,
    _: PayloadAction<ActionType, DeleteTranscript>,
): TranscriptSummaryState {
    return {
        ...state,
        pending: {
            ...state.pending,
            deleteTranscript: true,
        },
    };
}

export function deleteTranscriptResultReducer(
    state: TranscriptSummaryState,
    action: PayloadAction<ActionType, DeleteTranscriptResult>,
): TranscriptSummaryState {
    return {
        ...state,
        pending: {
            ...state.pending,
            deleteTranscript: false,
        },
    };
}
